<template>
  <v-container>
    <div class="d-flex flex-column justify-center">
      <div class="d-flex justify-center caption my-4">{{ text ? text : $t('loadingData') }}</div>
      <div class="d-flex full-width justify-center my-4"><dots></dots></div>
    </div>
  </v-container>
</template>

<script>
import Dots from '@/components/spinner/Dots';
export default {
  name: 'Loading',
  props: {
    text: String,
  },
  components: {
    Dots,
  },
};
</script>
